export enum EmbedSource {
  YouTube = 'YouTube',
  Staige = 'Staige',
}
